import { Route, Routes, Navigate } from "react-router-dom";
import IndexPage from "./pages";
import { User } from "./utils/helpers/types";
import NotFound from "./pages/not-found";
import "./styles/globals.scss";
import HistoryPage from "./pages/history";

const getRoutes: (user: User | null) => JSX.Element = () => {
  const defaultLink = "/";

  return (
    <Routes>
      <Route
        path="/spa/mc-acquirer-abu-mandate-portlet"
        element={<Navigate to={defaultLink} />}
      />

      <Route path="/" element={<IndexPage />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default getRoutes;
